var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6417 16.7272L24.0508 18.5226C23.8054 18.6518 23.5083 18.6001 23.3017 18.4064L20.8863 15.991C20.6279 15.7326 20.6279 15.3322 20.8863 15.0739L23.3404 12.6197C23.5342 12.4259 23.8442 12.3743 24.0896 12.5034L27.6417 14.286C28.6621 14.7768 28.6621 16.2235 27.6417 16.7272Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0542 10.9663C21.4546 11.1601 21.5321 11.6897 21.2221 11.9997L19.065 14.1567L18.1479 15.0738C17.8896 15.3322 17.4892 15.3322 17.2308 15.0738L8.00833 5.85132C7.49166 5.33465 8.09875 4.49508 8.7575 4.818L21.0542 10.9663Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.58334 26.0271V4.49507C2.58334 3.92673 3.26793 3.62963 3.68126 4.03005L15.0092 15.0221C15.2804 15.2805 15.2675 15.7067 14.9963 15.965L3.66834 26.505C3.25501 26.8925 2.58334 26.5955 2.58334 26.0271Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0154 20.0467L8.88668 26.1175C8.22793 26.4404 7.62084 25.6009 8.13751 25.0842L17.2438 15.9779C17.5021 15.7196 17.9025 15.7196 18.1608 15.9779L21.1963 19.0134C21.4933 19.3234 21.4029 19.8529 21.0154 20.0467Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.fcc052c0ba7e20a0d9e4688c7e3877f4.svg";
export { ForwardRef as ReactComponent };